module.exports = __webpack_public_path__ + "img/icon-result.1262c7b5.png";